var _path, _circle, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgMyLocation = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 23,
  height: 23
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "m11.5,19.75a8.193,8.193 0 0 0 8.25,-8.213a8.331,8.331 0 0 0 -7.694,-8.268c0.026,0 -0.263,-0.018 -0.556,-0.018a8.25,8.25 0 1 0 0,16.5l0,-0.001z",
  fill: "none",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  fillRule: "evenodd"
})), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 11.501,
  cy: 11.501,
  r: 4.813,
  fill: "currentColor"
})), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "m0.5,11.5l2.75,0",
  fill: "none",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  d: "m19.75,11.5l2.75,0",
  fill: "none",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  d: "m11.5,0.5l2.75,0",
  transform: "rotate(90 11.5,0.500000000000001) ",
  fill: "none",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  d: "m11.5,19.75l2.75,0",
  transform: "rotate(90 11.499999999999998,19.750000000000004) ",
  fill: "none",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  fillRule: "evenodd"
}))));
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjMiIGhlaWdodD0iMjMiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+DQogIDxwYXRoIGQ9Im0xMS41LDE5Ljc1YTguMTkzLDguMTkzIDAgMCAwIDguMjUsLTguMjEzYTguMzMxLDguMzMxIDAgMCAwIC03LjY5NCwtOC4yNjhjMC4wMjYsMCAtMC4yNjMsLTAuMDE4IC0wLjU1NiwtMC4wMThhOC4yNSw4LjI1IDAgMSAwIDAsMTYuNWwwLC0wLjAwMXoiIGZpbGw9Im5vbmUiIHN0cm9rZT0iY3VycmVudENvbG9yIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiIGZpbGwtcnVsZT0iZXZlbm9kZCIvPg0KICA8Y2lyY2xlIGN4PSIxMS41MDEiIGN5PSIxMS41MDEiIHI9IjQuODEzIiBmaWxsPSJjdXJyZW50Q29sb3IiLz4NCiAgPGc+DQogICAgPHBhdGggZD0ibTAuNSwxMS41bDIuNzUsMCIgZmlsbD0ibm9uZSIgc3Ryb2tlPSJjdXJyZW50Q29sb3IiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIgZmlsbC1ydWxlPSJldmVub2RkIi8+DQogICAgPHBhdGggZD0ibTE5Ljc1LDExLjVsMi43NSwwIiBmaWxsPSJub25lIiBzdHJva2U9ImN1cnJlbnRDb2xvciIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiLz4NCiAgICA8cGF0aCBkPSJtMTEuNSwwLjVsMi43NSwwIiB0cmFuc2Zvcm09InJvdGF0ZSg5MCAxMS41LDAuNTAwMDAwMDAwMDAwMDAxKSAiIGZpbGw9Im5vbmUiIHN0cm9rZT0iY3VycmVudENvbG9yIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiIGZpbGwtcnVsZT0iZXZlbm9kZCIvPg0KICAgIDxwYXRoIGQ9Im0xMS41LDE5Ljc1bDIuNzUsMCIgdHJhbnNmb3JtPSJyb3RhdGUoOTAgMTEuNDk5OTk5OTk5OTk5OTk4LDE5Ljc1MDAwMDAwMDAwMDAwNCkgIiBmaWxsPSJub25lIiBzdHJva2U9ImN1cnJlbnRDb2xvciIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiLz4NCiAgPC9nPg0KPC9zdmc+DQo=";
export { SvgMyLocation as ReactComponent };